<template>
  <div class="text-center p-a-md text-sm">蜀ICP备18009933号-1 &copy; {{title}} 2019</div>
</template>
<script>
export default {
  data() {
    return {
      title: ''
    }
  },
  mounted() {
    this.title = this.GLOBAL.title
  }
}
</script>

<style scoped>
</style>

